// La caja ESPEJO de la biblioteca — ADR-2026-09-16-con-el-lienzo-la-biblioteca-espeja-la-caja.
//
// En modo lienzo la biblioteca se abre ENCIMA del chat, y la miniatura que vuela al
// adjuntar aterrizaba en la caja real, tapada: el vuelo se veía irse a ninguna parte.
// Esta tira vive al pie de la biblioteca y muestra los MISMOS chips que el chat
// (`ChipAdjunto`, `ChipLote`: una segunda versión se desalinearía con la primera al
// primer cambio). Lleva `data-caja-del-agente="espejo"`, que es a donde el vuelo
// prefiere aterrizar.
//
// Mide lo que miden sus chips y nada más
// (ADR-2026-09-22-la-caja-espejo-mide-lo-que-miden-sus-chips). Antes calcaba a la caja
// real —cuerpo vacío de 118px incluido— para que los chips no se movieran al cerrar la
// biblioteca; con el lienzo abierto eso le comía a la grilla casi 300px con cinco
// adjuntos, la mitad de ellos en blanco. Ahora sin nada enganchado no se dibuja, y con
// muchos chips se corta a tres filas y scrollea por dentro: la grilla es lo que el
// usuario vino a mirar.

import { useChatAtlas } from '../ChatAtlasContext';
import { ChipAdjunto, ChipLote } from './BarraEntradaChat';
import { ATRIBUTO_CAJA, CAJA_ESPEJO } from './vueloAlComposer';

/** Tres filas de chips y a partir de ahí scrollea: 3 × 44 (el alto de un `ChipAdjunto`)
 *  + 2 × 8 de `gap-2` + 20 del `py-2.5`. Si el chip cambia de alto, cambia este número:
 *  de más quedaría aire al pie, de menos cortaría una fila entera. */
const ALTO_MAXIMO_CHIPS = 168;

export const CajaEspejoDeAdjuntos: React.FC = () => {
  const chat = useChatAtlas();
  const hayChips = chat.adjuntos.length > 0 || !!chat.loteFotos;
  // Sin chips no hay nada que espejar, y una caja vacía es alto que la grilla no tiene.
  // El vuelo busca el CHIP, que para cuando mide ya existe: no se queda sin destino.
  if (!hayChips) return null;
  return (
    // `px-4`: el mismo margen lateral que la conversación en modo lienzo
    // (`PantallaChatAtlas` le pasa `padding="px-4"`), así los chips se acomodan en las
    // mismas filas que en la caja real y el que vuela aterriza donde va a quedar.
    <div className="shrink-0 px-4 pb-3 pt-2">
      <div
        {...{ [ATRIBUTO_CAJA]: CAJA_ESPEJO }}
        className="rounded-3xl border border-neutral-300 bg-white p-1 shadow-sm"
      >
        <div
          className="flex flex-wrap items-center gap-2 overflow-y-auto px-2.5 py-2.5"
          style={{ maxHeight: ALTO_MAXIMO_CHIPS, scrollbarWidth: 'thin' }}
        >
          {chat.loteFotos && <ChipLote lote={chat.loteFotos} onQuitar={chat.quitarLoteFotos} />}
          {chat.adjuntos.map((a) => (
            <ChipAdjunto key={a.id} adjunto={a} onQuitar={() => chat.quitarAdjunto(a.id)} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CajaEspejoDeAdjuntos;
